(function () {
  // Same map as your Liquid snippet — add currencies here as needed
  var PREFIX_MAP = { AUD: 'A$', NZD: 'NZ$', CAD: 'C$' };

  function activeCurrency() {
    return window.__activeCurrency
      || (window.Shopify && Shopify.currency && Shopify.currency.active)
      || '';
  }

  // Price elements rendered outside Liquid (app cart drawer, discount blocks)
  var SELECTOR = '.price-discount-block .price, .footer-subtotal-prices .price, .slidecart-subtotal';

  var observer;

  function applyPrefix() { 
    var prefix = PREFIX_MAP[activeCurrency()];
    if (!prefix) return; // currency not customised -> leave default

    if (observer) observer.disconnect(); // avoid reacting to our own edits

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      // Only touch text that starts with a bare "$".
      // Already-prefixed text ("A$180.00") starts with a letter, so it's skipped -> idempotent.
      el.textContent = el.textContent.replace(/^\s*\$/, prefix);
    });

    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  // Watch for the cart drawer opening / quantity changes re-rendering prices
  observer = new MutationObserver(applyPrefix);
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', applyPrefix);
  applyPrefix();
})();
